module.exports = __webpack_public_path__ + "static/features-2.401b6444.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/features-2.png
// module id = 233
// module chunks = 0